/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

export const eventEntity = {

    entity: "event",
    label: "Event",

    fields: [

        {
            key: "event_id",
            label: "ID",
            type: "uuid",
            visible: false,
            editable: false
        },

        {
            key: "event_key",
            label: "Key",
            type: "text",
            required: true,
            visible: true,
            editable: true
        },

        {
            key: "event_type",
            label: "Type",
            type: "select",
            options: ["create", "update", "delete", "system"],
            visible: true,
            editable: true
        },

        {
            key: "source_identity_id",
            label: "Source Identity",
            type: "uuid",
            visible: true,
            editable: true
        },

        {
            key: "target_entity",
            label: "Target Entity",
            type: "text",
            visible: true,
            editable: true
        },

        {
            key: "target_id",
            label: "Target ID",
            type: "uuid",
            visible: true,
            editable: true
        },

        {
            key: "payload",
            label: "Payload",
            type: "json",
            visible: true,
            editable: true
        },

        {
            key: "created_at",
            label: "Created",
            type: "datetime",
            visible: false,
            editable: false
        }

    ]

}